<template>
  <div class="placement">
    <breadcrumbs :breadcrumbsData="breadcrumbsDataComputed" #icon>
      <svg class="icon" aria-hidden="true" style="color: #fff;">
        <use xlink:href="#icon-a-PaidPlacement"></use>

      </svg>
    </breadcrumbs>
    <div class="content-wrapper">
      <div class="table-head">
        <a-space>
          <ButtonGroups :pagination="{
            total: pagination.total,
            page: pagination.page,
            size: pagination.size,
          }" :tableData="dataSource" @pageChange="onPageChange" />
        </a-space>

        <a-space class="filters">
          <a-input-search v-model:value="queryParams.keyword" :placeholder="st('common.searchPlaceholder')" allow-clear @search="onSearch"
            @pressEnter="onSearch">
          </a-input-search>
        </a-space>
      </div>
      <div class="filterBar" ref="marketplaceRef">
        <div class="filterBar-content">
          <div class="statusFilter" ref="statusFilterRef">
            <span style="margin-right: 8px;" class="mid-filter-title">{{ st('common.status') }}</span>
            <artmisads-select v-model:value="queryParams.status" :getPopupContainer="() => statusFilterRef" :allowClear="true"
              style="width: 220px;" trigger="click">
              <a-select-option value="">{{ st('common.all') }}</a-select-option>
              <a-select-option value="pending">{{ st('campaigns.statusPending') }}</a-select-option>
              <a-select-option value="suspended">{{ st('campaigns.statusSuspended') }}</a-select-option>
              <a-select-option value="declined">{{ st('campaigns.statusDeclined') }}</a-select-option>
              <a-select-option value="accepted">{{ st('campaigns.statusAccepted') }}</a-select-option>
              <a-select-option value="cancelled">{{ st('campaigns.statusCanceled') }}</a-select-option>
              <a-select-option value="paid">{{ st('campaigns.statusInProgress') }}</a-select-option>
              <a-select-option value="confirming">{{ st('campaigns.statusConfirming') }}</a-select-option>
              <a-select-option value="confirmed">{{ st('campaigns.statusPublished') }}</a-select-option>

              <!-- <a-select-option value="published">Published</a-select-option> -->
              <!-- <a-select-option value="completed">Payment Received</a-select-option> -->
            </artmisads-select>
          </div>
          <div class="statusFilter" ref="operationRef">
            <span class="mid-filter-title" style="margin-right: 8px;">{{ st('placement.sort') }}</span>
            <artmisads-select v-model:value="queryParams.priceSort" style="width: 180px" :allowClear="true"
              :getPopupContainer="() => operationRef">
              <a-select-option value="asc">
                <Icon name="paixu1" class="iconAsc paixuIcon" />
                <span class="paixuText">{{ st('placement.sortByPrice') }}</span>
              </a-select-option>
              <a-select-option value="desc" class="paixuIcon">
                <Icon name="paixu1" />
                <span class="paixuText">{{ st('placement.sortByPrice') }}</span>
              </a-select-option>

            </artmisads-select>
          </div>
        </div>
      </div>
      <div class="table">
        <artmisads-table :columns="columns" :data-source="dataSource" :loading="loading"
          :scroll="{ x: 2000, y: tableScrollHeight }" :pagination="{
            total: pagination.total,
            pageSize: pagination.size,
            current: pagination.page,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50', '100', '200']
          }" :change="onChangePage">
          <template #bodyCell="{ column, text, index, record }">
            <template v-if="column.name === 'publisher'">
              <div class="publisher-info">
                <LogoImage :logoUrl="record.publisherHeadImageUrl" :brandName="record.publisherName" />
                <AutoTooltip :content="record.publisherName" :width="120" />
              </div>

            </template>
            <template v-if="column.name === 'name'">
              <AutoTooltip :content="record.name" :width="180" />
            </template>
            <template v-if="column.name === 'price'">
              {{ CURRENCY_DATA_MAPPER[record.currency] }} {{ record.amount.toFixed(2) }}
            </template>
            <template v-if="column.name === 'status'">
              <div v-if="record.status === 'completed'">
                <PlacementStatus :type="statusInfo[record.status]?.type || '--'"
                :text="st('campaigns.statusPublished')" />
              </div>
              <div v-else>
                <PlacementStatus :type="statusInfo[record.status]?.type || '--'"
                :text="statusInfo[record.status]?.text || '--'" />
              </div>
              
              <div>
                <span v-if="record.status === 'accepted' && record.paymentCountdown" class="countdownDisplay">
                  {{ st('campaigns.paymentCountdown', { time: record.countdownDisplay }) }}
                </span>
              </div>

            </template>


            <template v-if="column.name === 'applyDate'">
              {{ record.applyDate ? setTime(record.applyDate) : '-' }}
            </template>

            <template v-if="column.name === 'action'">
              <div class="action-buttons">
                <artmisads-select-button size="small" @click="viewPlacement(record.id)">{{ st('campaigns.btnView') }}</artmisads-select-button>
                <artmisads-select-button size="small" @click="suspendPlacement(record.id)"
                  v-if="record.status === 'pedding'">{{ st('campaigns.btnSuspend') }}</artmisads-select-button>
                <artmisads-select-button size="small" @click="payPlacement(record)"
                  v-if="record.status === 'accepted'">{{ st('campaigns.btnPay') }}</artmisads-select-button>
               
                
              </div>
              <artmisads-select-button style="margin-top: 10px;" size="small" @click="messagesPlacement(record)"
                    v-if="record.status === 'accepted' || record.status === 'confirming' || record.status === 'paid'">{{ st('campaigns.btnMessages') }}</artmisads-select-button>
               
            </template>
          </template>
        </artmisads-table>
      </div>

    </div>
    <invoiceModal :setDetailData="setDetailData" :payOrderList="payOrderList" v-if="showInvoiceModal" />
  </div>
</template>

<script setup>
import breadcrumbs from '@/components/breadcrumbs.vue'
import ButtonGroups from '@/components/buttonGroups.vue'
import { sellerCampaignsApi } from '~/server/index'
import AutoTooltip from '@/components/AutoTooltip.vue'
import LogoImage from '@/components/LogoImage.vue'
import { CURRENCY_DATA_MAPPER } from '~/contants/common'
import { useRouter } from 'vue-router'
import invoiceModal from './components/invoiceModal.vue'
import PlacementStatus from '@/components/placementStatus.vue'
import { statusInfo } from '@/contants/common'

import { ref, watch, onBeforeUnmount, computed } from 'vue'
import Icon from "@/components/Icon.vue"
import { useTableScrollHeight } from "@/utils/useTableScrollHeight"
import { useMessageDrawerStore } from '@/storeData/messageDrawer'
import { setTime } from '@/utils/index'
import { useSellerI18n } from '@/composables/useSellerI18n'
import { message, Modal } from 'ant-design-vue'

const { st } = useSellerI18n()
const store = useMessageDrawerStore()
const { tableScrollHeight } = useTableScrollHeight({
  selector: '.table',
  bottomSpace: 280,
  minHeight: 300,
  maxHeight: 1000,
  defaultHeight: 350
})
const loading = ref(false)
const marketplaceRef = ref(null)
const statusFilterRef = ref(null)
const operationRef = ref(null)
const router = useRouter()
const queryParams = ref({
  keyword: '',
  status: '',

  priceSort: 'asc'
})
const payOrderList = ref(null)
const showInvoiceModal = ref(false)
const columns = computed(() => [
  {
    title: st('campaigns.colTitle'),
    dataIndex: 'title',
    name: 'title',
    width: 200,
  },
  {
    title: st('campaigns.colPublisher'),
    dataIndex: 'publisher',
    name: 'publisher',
    width: 200,
  },
  {
    title: st('campaigns.colStatus'),
    dataIndex: 'status',
    name: 'status',
    width: 200,
  },
  {
    title: st('campaigns.colPlacementName'),
    dataIndex: 'placementName',
    name: 'placementName',
    width: 200,
  },
  {
    title: st('campaigns.colPrice'),
    dataIndex: 'price',
    name: 'price',
    width: 100,
  },
  {
    title: st('campaigns.colPlacementDescription'),
    dataIndex: 'placementDescription',
    name: 'placementDescription',
    width: 350,
  },
  {
    title: st('campaigns.colApplyDate'),
    dataIndex: 'applyDate',
    name: 'applyDate',
    width:100
  },
  {
    title: st('campaigns.colAction'),
    name: 'action',
    fixed: 'right',
    width: 120
  },
])
watch(queryParams, () => {
  pagination.value.page = 1
  pagination.value.size = 10
  getList()
}, {
  deep: true,
  immediate: false,
})
const dataSource = ref([])
const pagination = ref({
  total: 30,
  defaultPageSize: 10,
  size: 10,
  page: 1,
  showSizeChanger: true,

})
const paymentCountdown = ref([])
const countdownTimer = ref(null)
const breadcrumbsDataComputed = computed(() => ({
  title: st('campaigns.pageTitle'),
  des: st('campaigns.pageDes'),
  color: '#80C026',
  links: [
    {
      name: st('common.home'),
      path: "/seller/dashboard",
    },
    {
      name: st('placement.breadcrumbPaidPlacements'),
      path: "/seller/Settings/paidPlacement/campaigns",
    },
    {
      name: st('campaigns.pageTitle'),
      path: "/seller/Settings/paidPlacement/campaigns",
    },
  ],
}))
const onPageChange = (page) => {

  pagination.value.page = page

  getList()

}
const onChangePage = (data) => {
  const { current, pageSize } = data
  pagination.value.page = current
  pagination.value.size = pageSize
  getList()
}
const parseCountdownToSeconds = (value) => {
  if (!value || typeof value !== 'string') return 0
  const parts = value.split(':')
  if (parts.length !== 3) return 0
  const [hStr, mStr, sStr] = parts
  const hours = Number(hStr)
  const minutes = Number(mStr)
  const seconds = Number(sStr)
  if ([hours, minutes, seconds].some(n => Number.isNaN(n) || n < 0)) return 0
  return hours * 3600 + minutes * 60 + seconds
}
const formatSecondsToHHMMSS = (totalSeconds) => {
  if (totalSeconds <= 0) return '00:00:00'
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  const hh = String(hours).padStart(2, '0')
  const mm = String(minutes).padStart(2, '0')
  const ss = String(seconds).padStart(2, '0')
  return `${hh}:${mm}:${ss}`
}
const formatToHHMMSS = (value) => {
  return formatSecondsToHHMMSS(parseCountdownToSeconds(value))
}
const stopCountdownTimer = () => {
  if (countdownTimer.value) {
    clearInterval(countdownTimer.value)
    countdownTimer.value = null
  }
}
const prepareCountdownData = () => {
  if (!Array.isArray(dataSource.value)) return
  dataSource.value.forEach(record => {
    if (record && record.status === 'accepted' && record.paymentCountdown) {
      const remaining = parseCountdownToSeconds(record.paymentCountdown)
      record._remainingSeconds = remaining
      record.countdownDisplay = formatSecondsToHHMMSS(remaining)
    } else {
      record._remainingSeconds = undefined
      record.countdownDisplay = undefined
    }
  })
}
const startCountdownTimer = () => {
  stopCountdownTimer()
  countdownTimer.value = setInterval(() => {
    if (!Array.isArray(dataSource.value)) return
    let anyActive = false
    dataSource.value.forEach(record => {
      if (typeof record?._remainingSeconds === 'number') {
        if (record._remainingSeconds > 0) {
          record._remainingSeconds -= 1
          anyActive = true
        }
        record.countdownDisplay = formatSecondsToHHMMSS(record._remainingSeconds)
      }
    })
    if (!anyActive) {
      stopCountdownTimer()
    }
  }, 1000)
}
const isImage = (url) => {
  if (!url) return
  return url.includes('.jpg') || url.includes('.jpeg') || url.includes('.png')
}
const setDetailData = (data, type, hasCompleteInfo = false, setShowNotice = false) => {
  showInvoiceModal.value = false

}
const onSearch = () => {
  pagination.value.page = 1
  pagination.value.size = 10
  getList()
}
const getList = () => {
  loading.value = true

  const params = {
    ...queryParams.value,
    ...pagination.value,
  }
  // 处理 attribution 和 associate 参数逻辑


  // 删除原始参数，避免重复传递


  // 根据参数值设置 linkType

  // 两个都不选中时，不设置 linkType

  sellerCampaignsApi.getCampaigns(params).then(res => {
    dataSource.value = res.data.data
    pagination.value.total = res.data.total
    prepareCountdownData()
    startCountdownTimer()
  }).finally(() => {
    loading.value = false
  })
}
const viewPlacement = (id) => {
  router.push(`/seller/Settings/paidPlacement/campaigns/${id}`)
}
const payPlacement = (record) => {
  payOrderList.value = record
  showInvoiceModal.value = true
}
const messagesPlacement = (record) => {
  const conversationPartnerId = record.conversationPartnerId
  store.show(conversationPartnerId)
}
const suspendPlacement = (campaignId) => {
  Modal.confirm({
    title: st('campaigns.suspendConfirmTitle'),
    content: st('campaigns.suspendConfirmContent'),
    onOk: () =>
      sellerCampaignsApi.suspendCampaign({ campaignId }).then((res) => {
        if (res.success) {
          message.success(st('campaigns.suspendSuccess'))
          getList()
        } else {
          message.error(res.error || st('campaigns.suspendFailed'))
        }
      }).catch(() => {
        message.error(st('campaigns.suspendFailed'))
      }),
  })
}
// setTimeout(() => {
//   applicationModelRef.value.handleOpen()
// }, 1000)
onBeforeUnmount(() => {
  stopCountdownTimer()
})
getList()
</script>

<style scoped lang="less">
.action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.countdownDisplay {
  color: #EB4E3D;
}

.table {
  margin-top: 16px;
}

.iconAsc {
  transform: rotate(180deg);
}

.paixuText {
  margin-left: 4px;
}

.iconlinkType {
  width: 24px !important;
  height: 24px !important;
}

.linkType {
  display: flex;
  align-items: center;
  gap: 5px;
}

.placement {
  padding: 16px;
  padding-top: unset;
  width: 100%;

  .publisher-info {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .content-wrapper {
    display: block !important;
    background-color: #fff;
    padding: 16px;

    .table-head {
      display: flex;
      align-items: center;
      gap: 16px;
    }
  }

  .mid-filter {
    display: flex;
    align-items: space-between;
    position: relative;
    margin-bottom: 16px;
    margin-top: 16px;
    // justify-content: space-between;
    padding: 16px;
    padding-right: 96px;
    border-radius: 8px;
    background-color: var(--bg-gray-1);
    flex-wrap: wrap;
    gap: 16px; // 垂直和水平间距都是16px
    // overflow: hidden;
    max-height: 86px; // 限制为一行的高度，不包括gap，因为第一行不会有gap
    transition: max-height 0.3s ease;


    &-item {
      display: flex;
      flex-direction: column;
      // width: 20%;

      &.filter-item-hidden {
        display: none !important;
      }
    }

    &-checkbox {
      background-color: var(--bg-gray-6);
      border-radius: 8px;
      height: 32px;
      padding: 0 8px;
      display: flex;
      align-items: center;
      // justify-content: center;
    }

    &-title {
      font-size: 13px;
      font-weight: 600;
      height: 18px;
      // opacity: 0.7;
      letter-spacing: 0.3px;
      line-height: 18px;
      color: #0F0629;
      margin-bottom: 4px;
    }
  }

  .filterBar {
    width: 100%;
    padding: 16px;
    display: flex;
    border-radius: 8px;
    margin-top: 16px;
    align-items: center;
    background: #f8f7fc;
    justify-content: space-between;

    .filterBar-content {
      gap: 16px;
      display: flex;

      .statusFilter {
        display: flex;
        align-items: center;
      }

      .item {
        display: flex;
        flex-direction: column;

        >span {
          color: var(--dark-2);
          font-weight: 500;
          font-size: 13px;
          letter-spacing: 0.3px;
          line-height: 18px;
          margin-bottom: 4px;
        }
      }
    }
  }
}
</style>